export enum ResiduManagement {
    BURY = "enfouis",
    SURFACE = "laisses_en_surface"
}